import { axiosInstance } from "@refinedev/simple-rest";

import type { BlendPreviewPayload, BlendPreviewResponse } from "./types";

export async function previewBlend(
  apiUrl: string,
  payload: BlendPreviewPayload,
): Promise<BlendPreviewResponse> {
  const response = await axiosInstance.post(`${apiUrl}/blends/preview`, payload, {
    params: { "api-version": "1.0" },
  });
  return response.data as BlendPreviewResponse;
}
